import { render, staticRenderFns } from "./answerdetail.vue?vue&type=template&id=4c77b582&scoped=true&"
import script from "./answerdetail.vue?vue&type=script&lang=js&"
export * from "./answerdetail.vue?vue&type=script&lang=js&"
import style0 from "./answerdetail.vue?vue&type=style&index=0&id=4c77b582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c77b582",
  null
  
)

export default component.exports